import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Modal, Row, Button, Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'
import moment from "moment/moment";
import { useDispatch, useSelector } from "react-redux";
import APICom from "../../utils/helpers/APICom";
import TimePicker from "rc-time-picker";
import ConfirmationModal from '../Controls/ConfirmationModal';
import PersistStorage from "../../utils/helpers/PersistStorage";


function IsGridDataExists(props)
{
    try {
       let lengthOfGridData =  props?.GridRowData?.length;
       if(lengthOfGridData > 0)
       {
            return lengthOfGridData;
       }
       else
       {
        return 0;
       }
    } catch (error) {
        return 0;
    }
}

function TripDetailsDialog(props){

    const [pickRemarks, setPickRemarks] = useState("");
    const ChangePickRemarks = (pickRmks) => {
        setPickRemarks(pickRmks);
    }

    const [dropRemarks, setDropRemarks] = useState("");
    const ChangeDropRemarks = (dropRmks) => {
        setDropRemarks(dropRmks);
    }

    const xCancelSourceForGrid = useRef(null);
    useEffect(()=>{
        if(props.GridRowData.length === 0)
        {
            setActivateAlert({...activateAlert, alertTitle: 'No Trip Selected', alertMsg:'Please select a trip to continue...'});
            setShowActivationAlert(true);
        }

        const GetMRMSDetailedData = async(ConfirmationNo)=>{
            try{
              let data = {
                "confirmationno": String(ConfirmationNo),
                "dtPickupDate": "",
                "iRoutedFilter": -1,
                "imode": 2,
                "dHoursToShowFutureTrips": -1
              };
              let response = await APICom.fetchData("","GridData/GetMRMSDetailedData", "post", {}, data, xCancelSourceForGrid.current);
              if(response != undefined && response != null && response?.data != null && response?.data != undefined){
                if(response?.data?.vPickRemarks != undefined && response?.data?.vPickRemarks != null){
                    setPickRemarks(response.data.vPickRemarks);
                }
                if(response?.data?.vDropRemarks != undefined && response?.data?.vDropRemarks != null){
                    setDropRemarks(response.data.vDropRemarks);
                }
              }
            }
            catch(err){console.log(err);}
        }
        GetMRMSDetailedData(ConfirmationNumber);
    }, []);
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Will Call Warning',
    body:'You are updating a will call request, its time will also be updated', btnCanceText: 'Cancel', btnOkText: 'Ok'});

    const { ASCSSettingData }  = useSelector((store) => store.combinedata);

    const SPACES = "\u00A0\u00A0";
    const TITLE = "Trip Details";
    const EDIT_BUTTON = "Edit";
    const SAVE_BUTTON = "Save";
    const CANCEL_BUTTON = "Cancel";

    let ConfirmationNumber = IsGridDataExists(props) > 0 ? props.GridRowData[0]["ConfirmationNo"] : "";
    let ServiceStatus = IsGridDataExists(props) > 0 ? props.GridRowData[0]["ServiceStatus"] : "";
    let RequestType = IsGridDataExists(props) > 0 ? props.GridRowData[0]["RequestType"] : "";
    let ServiceId = IsGridDataExists(props) > 0 ? props.GridRowData[0]["ServiceID"] : -1;
    let PickupDateTime = IsGridDataExists(props) > 0 ? props.GridRowData[0]["PickupDateTime"] : "";
    let ReceivedDate = IsGridDataExists(props) > 0 ? props.GridRowData[0]["CallRecieve"] : "";
    let CreatedBy = IsGridDataExists(props) > 0 ? props.GridRowData[0]["CreatedBy"] : "";
    let ModifiedBy = IsGridDataExists(props) > 0 ? props.GridRowData[0]["LastModifiedBy"] : "";
    let RequestedVehicleType = IsGridDataExists(props) > 0 ? (props.GridRowData[0]["ReqVehType"]==="" || props.GridRowData[0]["ReqVehType"]===null? "None": props.GridRowData[0]["ReqVehType"]):"";
    let RequestedVehicleDriver = IsGridDataExists(props) > 0 ? props.GridRowData[0]["VREQ"] : "";
    let DriverPhone = IsGridDataExists(props) > 0 ? props.GridRowData[0]["DriverCellPhone"] : "";
    let LastCallback = IsGridDataExists(props) > 0 ? props.GridRowData[0]["DateCallback"] : "";
    let CallbackMethod = IsGridDataExists(props) > 0 ? props.GridRowData[0]["CallbackMethod"] : "";
    let CalloutStatus = IsGridDataExists(props) > 0 ? (props.GridRowData[0]["CallOutStatus"]==="" || props.GridRowData[0]["CallOutStatus"]===null? "None":props.GridRowData[0]["CallOutStatus"]) : "";
    let EstimatedMiles = IsGridDataExists(props) > 0 ? props.GridRowData[0]["EstimatedDistance"] : "";
    let EstimatedFare = IsGridDataExists(props) > 0 ? props.GridRowData[0]["EstimatedCost"] : "";
    let EstimatedMins = IsGridDataExists(props) > 0 ? props.GridRowData[0]["EstimatedTime"] : "";
    let InstructionsCount = IsGridDataExists(props) > 0 ? props.GridRowData[0]["iInstructionCount"] : "";
    let ProviderMiles = IsGridDataExists(props) > 0 ? props.GridRowData[0]["ProviderMileage"] : "";
    let ProviderFare = IsGridDataExists(props) > 0 ? props.GridRowData[0]["ProviderCost"] : "";
    let PayType = IsGridDataExists(props) > 0 ? props.GridRowData[0]["PaymentMethod"] : "";
    let Account = IsGridDataExists(props) > 0 ? props.GridRowData[0]["FundingSource"] : "";
    let PickupZip = IsGridDataExists(props) > 0 ? props.GridRowData[0]["PickupZip"] : "";
    let DropOffZip = IsGridDataExists(props) > 0 ? props.GridRowData[0]["DropZip"] : "";
    let PaymentExtention1 = IsGridDataExists(props) > 0 ? props.GridRowData[0]["PaymentExtention1"] : "";
    let PaymentExtention3 = IsGridDataExists(props) > 0 ? props.GridRowData[0]["PaymentExtention3"] : "";
    let iFundingSourceID = IsGridDataExists(props) > 0 ? props.GridRowData[0]["iFundingSourceID"] : "";
    let TableSource = IsGridDataExists(props) > 0 ? props.GridRowData[0]["TableSource"] : "";
    

    const [ScheduleTripMinTimeDiff, setScheduleTripMinTimeDiff] = useState(0);

    const { loginData } = useSelector((store) => store.login);

    const [showActivationAlert, setShowActivationAlert] = useState(false);
    const [activateAlert, setActivateAlert] = useState({alertTitle: '', alertMsg:''});

    const [isEditButtonClicked, setIsEditButtonClicked] = useState(true);

    const handleCloseTripDetailsDialog = () => {
        if (props.showTripDetailsDialog) {
            let IsTripDetailsDialogOpened = PersistStorage.retrieve("IsTripDetailsDialogOpened", false);
            if(IsTripDetailsDialogOpened != undefined && IsTripDetailsDialogOpened != null)
            {
                PersistStorage.save("IsTripDetailsDialogOpened", false, 0, false);
            }
            props.setTripDetailsDialog(false);
        }
    }

    const handleEditButton = () => {
        if(isEditButtonClicked)
        {
            setIsEditButtonClicked(false);
        }
        else
        {
            setIsEditButtonClicked(true);
        }
    }

    let _PickupPerson = IsGridDataExists(props) > 0 ? props.GridRowData[0]["PickupPerson"] : "";
    const [PickupPerson, setPickupPerson] = useState(_PickupPerson);
    const ChangePickupPerson = (name) => {
        setPickupPerson(name);
    }

    let _CallbackInfo = IsGridDataExists(props) > 0 ? props.GridRowData[0]["CallbackInfo"] : "";
    const [CallbackInfo, setCallBackInfo] = useState(_CallbackInfo);
    const ChangeCallbackInfo = (callbackInfo) => {
        setCallBackInfo(callbackInfo);
    }

    
    let _AppointmentTime = IsGridDataExists(props) > 0 ? props.GridRowData[0]["ApptTime"] : "";
    let activateTimeT = "";
    if(_AppointmentTime != "")
    {
        activateTimeT = moment(_AppointmentTime, 'HH:mm');
    }
    else
    {
        activateTimeT = moment('00:00', 'HH:mm');
    }

    
    const [AppointmentTime, setAppointmentTime] = useState(activateTimeT);
    const ChangeAppointmentTime = (appTime) => {
        if(appTime !== null)
        {
            let activateAppt = moment(appTime, 'HH:mm');
            setAppointmentTime(activateAppt);
        }
    }

    let _JobNumber = IsGridDataExists(props) > 0 ? props.GridRowData[0]["PaymentExtention2"] : "";
    const [JobNumber, setJobNumber] = useState(_JobNumber);
    const ChangeJobNumber = (jobNumber) => {
        setJobNumber(jobNumber);
    }

    let _ExtraInfo = IsGridDataExists(props) > 0 ? props.GridRowData[0]["ExtraInformation"] : "";
    const [ExtraInfo, setExtraInfo] = useState(_ExtraInfo);
    const ChangeExtraInfo = (extraInfo) => {
        setExtraInfo(extraInfo);
    }

    const GetTotalCanclNoShow = () => {
        let noShow = (IsGridDataExists(props) > 0 ? (props.GridRowData[0]["TotalNoShows"] ? props.GridRowData[0]["TotalNoShows"] : 0) : "");
        let totalCancelled = (IsGridDataExists(props) > 0 ? (props.GridRowData[0]["TotalCancelled"] ? props.GridRowData[0]["TotalCancelled"] : 0) : "");
        noShow = (noShow == '') ? 0 : noShow;
        let totalCancelNoShow = totalCancelled + " / " + noShow;

        return totalCancelNoShow
    }

    const GetPickupAddressPOI = () => {
        let PickupAddress = IsGridDataExists(props) > 0 ? props.GridRowData[0]["PickupAddress"] : "";
        let POI = "/" + IsGridDataExists(props) > 0 ? props.GridRowData[0]["PickupPOI"] : "";
        let PickupAddressPOI = PickupAddress + POI;

        return PickupAddressPOI
    }

    const GetDropoffAddressPOI = () => {
        let DropOffAddress = IsGridDataExists(props) > 0 ? props.GridRowData[0]["Destination"] : "";
        let DropPOI = "/" + IsGridDataExists(props) > 0 ? props.GridRowData[0]["DropoffPOI"] : "";
        let DropOffAddressPOI = DropOffAddress + DropPOI;

        return DropOffAddressPOI
    }

    let PickupAddressPOI = GetPickupAddressPOI();
    let DropOffAddressPOI = GetDropoffAddressPOI();

    const _startDate = new Date();
    const _TodayDate = _startDate.getFullYear() + (_startDate.getMonth() < 9 ? "-0" : "-") + (_startDate.getMonth() + 1) + "-" + _startDate.getDate()
    const [ToolboxValues, SetToolboxValues] = useState({
        Date:_TodayDate
    });
    
    let pickupDte = PickupDateTime != "" ? PickupDateTime.split(' ')[0] : "1/1/1900";
    const [pickupDate, setDateValue] = useState(new Date(pickupDte));
    const handlePickupDateChange = (date) => {
        const newDate = new Date(date);
        setDateValue(newDate);
    };


    let pickuptimePart = PickupDateTime != "" ? PickupDateTime.split(' ')[2] : "1/1/1900";
    if(pickuptimePart == undefined) { pickuptimePart = PickupDateTime != "" ? PickupDateTime.split(' ')[1] : ""; }
    let activateTime = ""
    if(pickuptimePart != "")
    {
        activateTime = moment(pickuptimePart, 'hh:mm A');
    }
    else
    {
        activateTime = moment('00:00 A', 'hh:mm A');
    }
    const [pickupTime, setTimeValue] = useState(activateTime);
    const handleRequestPickupTimeChange = (pickTime) => {
        if(pickTime !== null)
        {
          let activateAppt = moment(pickTime, ' hh:mm A');
          setTimeValue(activateAppt);
        }
    }

    const handleAlertModalClose = () => {
        setShowActivationAlert(false);
    }

    const handleValidateTripInformation = async() => {
        let tripInformationObject = 
        { "iServiceID": "-1", "vPickupPerson" : "", "dtPickupDate": "", "iPaymentTypeID" : '', 
        "vExt1" : '',"vExt2" : '', "vExt3" : '', "vCallBackInfo" : '', "vCustomerEmail" : '',
        "vExtraInfo" : '', "fundingSourceID" : '', "dtAppTime" : '', "RefID": "-1", "iUserID": "-1",
        "vPickupRemarks": '', "vDropRemarks": ""
        };

        getScheduleTripMinTimeDiff();
        const dateMoment = moment(pickupDate, 'YYYY-MM-DD');
        const timeMoment = moment(pickupTime, 'HH:mm A');

        const combinedMoment = dateMoment.set({
            hour: timeMoment.hours(),
            minute: timeMoment.minutes(),
            second: timeMoment.seconds(),
        });
        let datetime = combinedMoment.format('YYYY-MM-DD HH:mm A');
        let Apptdatetime = "1900-01-01 12:00 AM";
        if(AppointmentTime.hours() > 0 || AppointmentTime.minutes() > 0 || AppointmentTime.seconds() > 0){
            let combinedMomentApptTime = dateMoment.set({
                hour: AppointmentTime.hours(),
                minute: AppointmentTime.minutes(),
                second: AppointmentTime.seconds(),
            });
            Apptdatetime = combinedMomentApptTime.format('YYYY-MM-DD hh:mm A');
        }
        
        tripInformationObject["ServiceID"] = ServiceId;
        tripInformationObject["vPickupPerson"] = PickupPerson;
        tripInformationObject["dtPickupDate"] = datetime != "" ? datetime : "";
        tripInformationObject["iPaymentTypeID"] = -1;
        tripInformationObject["vExt1"] = PaymentExtention1;
        tripInformationObject["vExt2"] = JobNumber;
        tripInformationObject["vExt3"] = PaymentExtention3;
        tripInformationObject["vCallBackInfo"] = CallbackInfo;
        tripInformationObject["vCustomerEmail"] = "";
        tripInformationObject["fundingSourceID"] = String(iFundingSourceID);
        tripInformationObject["dtAppTime"] = Apptdatetime;
        tripInformationObject["RefID"] = ConfirmationNumber;
        tripInformationObject["iUserID"] = loginData.iUserID;
        tripInformationObject["vExtraInfo"] = ExtraInfo;
        tripInformationObject["vPickupRemarks"] = pickRemarks;
        tripInformationObject["vDropRemarks"] = dropRemarks;

        let result = await validationForTripInformationSaving(tripInformationObject);
        if(result == true){
            tripInformationObject["dtPickupDate"] = tripInformationObject["dtPickupDate"].replace('AM','');
            tripInformationObject["dtPickupDate"] = tripInformationObject["dtPickupDate"].replace('PM','');
            tripInformationObject["dtPickupDate"] = tripInformationObject["dtPickupDate"];
            handleSaveTripInformation(tripInformationObject);
        }
        let IsTripDetailsDialogOpened = PersistStorage.retrieve("IsTripDetailsDialogOpened", false);
        if(IsTripDetailsDialogOpened != undefined && IsTripDetailsDialogOpened != null)
        {
            PersistStorage.save("IsTripDetailsDialogOpened", false, 0, false);
        }
    }

    


    const handleSaveTripInformation = async(tripInformationObject) => {
        try {
            let response = await APICom.fetchData("", "DispatchActions/UpdatePartialTripInformation", "post", { "Content-Type": "application/json" }, tripInformationObject, null);
            let result = response.data;
            if(Number(result.length) > 0)
            {
                setActivateAlert({...activateAlert, alertTitle: 'Updated', alertMsg:'Successfully updated.'});
                setShowActivationAlert(true);
                handleCloseTripDetailsDialog(); 
                return false;
            }
            else
            {
                setActivateAlert({...activateAlert, alertTitle: 'Upate Failed', alertMsg:'Unable to update.'});
                setShowActivationAlert(true);
                return false;
            }
        } catch (error) {
            
        }
    }

    const validationForTripInformationSaving = async (tripInformationObject) => {
        let _isScheduled = false;
        try {
            if(tripInformationObject !== undefined)
            {
                if(tripInformationObject["fundingSourceID"] == undefined || tripInformationObject["fundingSourceID"] == ""){
                    setActivateAlert({...activateAlert, alertTitle: 'Missing Fields', alertMsg:'Funding Source cannot be empty.'});
                    setShowActivationAlert(true);
                    return false;
                }
                if(tripInformationObject["iPaymentTypeID"] == undefined || tripInformationObject["iPaymentTypeID"] == ""){
                    setActivateAlert({...activateAlert, alertTitle: 'Missing Fields', alertMsg:'Payment type cannot be empty.'});
                    setShowActivationAlert(true);
                    return false;
                }
                if(tripInformationObject["dtPickupDate"] == undefined || tripInformationObject["dtPickupDate"] == ""){
                    setActivateAlert({...activateAlert, alertTitle: 'Missing Fields', alertMsg:'Please enter a valid PU Date.'});
                    setShowActivationAlert(true);
                    return false;
                }
                if(pickupTime == undefined || pickupTime == ""){
                    setActivateAlert({...activateAlert, alertTitle: 'Missing Fields', alertMsg:'Please enter a valid PU Time.'});
                    setShowActivationAlert(true);
                    return false;
                }
                _isScheduled = setIsScheduled(tripInformationObject["dtPickupDate"], PickupDateTime);

                if(_isScheduled)
                {
                    let ServerDBDateTime = await getServerTime();
                    let formattedServerDBDateTime;

                    let _ScheduleTripMinTimeDiff = 0;
                    if(ScheduleTripMinTimeDiff != undefined && ScheduleTripMinTimeDiff != -1){
                        _ScheduleTripMinTimeDiff = ScheduleTripMinTimeDiff / 60;
                    }


                    if(ServerDBDateTime != undefined)
                    {
                        let _serverDate = ServerDBDateTime.split(' ')[0];
                        let _serverTime = ServerDBDateTime.split(' ')[1];

                        _serverDate = new Date(_serverDate);
                        _serverTime = moment(_serverTime, 'hh:mm A');

                        const tempServerDate = moment(_serverDate, 'YYYY-MM-DD');
                        const tempServerTime = moment(_serverTime, 'HH:mm');

                        formattedServerDBDateTime = tempServerDate.set({
                            hour: tempServerTime.hours(),
                            minute: tempServerTime.minutes(),
                            second: tempServerTime.seconds(),
                        });

                        formattedServerDBDateTime = formattedServerDBDateTime.clone().add(_ScheduleTripMinTimeDiff, 'minutes');

                        formattedServerDBDateTime = formattedServerDBDateTime.format('YYYY-MM-DD HH:mm A');

                    }

                    const minDate = new Date(1,0,1);
                    if(tripInformationObject["dtPickupDate"] == minDate.toISOString())
                    {
                        setActivateAlert({...activateAlert, alertTitle: 'Schedule Date & Time', alertMsg:'Please enter a valid time value for schedule time.'});
                        setShowActivationAlert(true);
                        return false;
                    }
                    
                    //const differenceInMinutes = formattedServerDBDateTime.diff(moment(tripInformationObject["dtPickupDate"], 'YYYY-MM-DD HH:mm'), 'minutes');
                   
                    let selectedDateTime = moment(tripInformationObject["dtPickupDate"], 'YYYY-MM-DD HH:mm A');
                    let serverDT = moment(formattedServerDBDateTime,  'YYYY-MM-DD HH:mm A');

                    if (serverDT.isAfter(selectedDateTime) && RequestType.toUpperCase() != "WILLCALL") {
                        setActivateAlert({...activateAlert, alertTitle: 'Schedule Date & Time', alertMsg:"The current time is [" + 
                            ServerDBDateTime.toString() + "]," + " please choose [" + _ScheduleTripMinTimeDiff.toString() + 
                            "] mins ahead of current time to book a scheduled ride."});
                        setShowActivationAlert(true);
                        return false;
                    }

                    if(RequestType.toUpperCase() == "WILLCALL"){
                        setConfirmationModalObj((prevState) => ({...prevState, ...{show: true, title:"Will Call Warning", 
                        body:"You are updating a will call request, its time will also be updated", 
                        btnCancelText: 'Cancel', btnOkText: 'Ok'}}));
                        return false;
                    }
                    return true;
                }
                else
                {
                    return true;
                }
            }
        } catch (error) {
            return false;
        }
    }

    function setIsScheduled(newPUDateTime, oldPUDateTime)
    {
        let _isScheduled = false;
        try {
            if(TableSource == "FromOnDemandTable"){
                if (newPUDateTime != moment(oldPUDateTime, 'MM/DD/YYYY hh:mmA').format('MM/DD/YYYY') ||
                    newPUDateTime != moment(oldPUDateTime, 'MM/DD/YYYY hh:mmA').format('hh:mmA')) {
                     _isScheduled = true;
                 }
             }
             else{
                 _isScheduled = true;
             }
        } catch (error) {
            return false;
        }
        return _isScheduled;
    }

    async function getServerTime()
    {
        try {
            let response = await APICom.fetchData("", "TripActions/GetCurrentDBDateTime", "post", { "Content-Type": "application/json" }, {}, null);
            let result = response.data;
            return result;

        } catch (error) {
            return null;
        }
    }

    function getScheduleTripMinTimeDiff()
    {
        if(ASCSSettingData !== null && ASCSSettingData !== undefined)
        {
            let _iSRATSPID = IsGridDataExists(props) > 0 ? props.GridRowData[0].iSRATSPID : -1;
            if (ASCSSettingData.hasOwnProperty(props?.GridRowData[0]?.iSRATSPID)) {
                const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[_iSRATSPID]); // Parse JSON string into an array
                for(let i=0; i < ascsSettingDataByAffiliate.length; i++)
                {
                    if(ascsSettingDataByAffiliate[i]["SubTitle"] === "ScheduleTripMinTimeDiff")
                    {
                        setScheduleTripMinTimeDiff(ascsSettingDataByAffiliate[i]["value"]);
                    }
                }
            }
        }
    }

    const handleConfirmationModalOk = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        handleConfirmationModalOkFunction();
    }

    const handleConfirmationModalCancel = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
    }

    var handleConfirmationModalOkFunction = () => {
        let tripInformationObject = 
        { "iServiceID": "-1", "vPickupPerson" : "", "dtPickupDate": "", "iPaymentTypeID" : '', 
        "vExt1" : '',"vExt2" : '', "vExt3" : '', "vCallBackInfo" : '', "vCustomerEmail" : '',
        "vExtraInfo" : '', "fundingSourceID" : '', "dtAppTime" : '', "RefID": "-1", "iUserID": "-1" 
        };

        getScheduleTripMinTimeDiff();
        const dateMoment = moment(pickupDate, 'YYYY-MM-DD');
        const timeMoment = moment(pickupTime, 'HH:mm A');

        const combinedMoment = dateMoment.set({
            hour: timeMoment.hours(),
            minute: timeMoment.minutes(),
            second: timeMoment.seconds(),
        });
        let datetime = combinedMoment.format('YYYY-MM-DD HH:mm A')
        
        tripInformationObject["ServiceID"] = ServiceId;
        tripInformationObject["vPickupPerson"] = PickupPerson;
        tripInformationObject["dtPickupDate"] = datetime != "" ? datetime : "";
        tripInformationObject["iPaymentTypeID"] = -1;
        tripInformationObject["vExt1"] = PaymentExtention1;
        tripInformationObject["vExt2"] = JobNumber;
        tripInformationObject["vExt3"] = PaymentExtention3;
        tripInformationObject["vCallBackInfo"] = CallbackInfo;
        tripInformationObject["vCustomerEmail"] = "";
        tripInformationObject["fundingSourceID"] = String(iFundingSourceID);
        tripInformationObject["dtAppTime"] = AppointmentTime;
        tripInformationObject["RefID"] = ConfirmationNumber;
        tripInformationObject["iUserID"] = loginData.iUserID;
        tripInformationObject["vExtraInfo"] = ExtraInfo;
        tripInformationObject["vPickupRemarks"] = pickRemarks;
        tripInformationObject["vDropRemarks"] = dropRemarks;

        
        tripInformationObject["dtPickupDate"] = tripInformationObject["dtPickupDate"].replace('AM','');
        tripInformationObject["dtPickupDate"] = tripInformationObject["dtPickupDate"].replace('PM','');
        tripInformationObject["dtPickupDate"] = tripInformationObject["dtPickupDate"];
        handleSaveTripInformation(tripInformationObject);
    }


    return (
        
        <>
            {props.showTripDetailsDialog && props.GridRowData.length > 0 ? 
                <Modal show={props.showTripDetailsDialog ? 1 : 0} centered onHide={handleCloseTripDetailsDialog} backdrop="static" keyboard={true}  size="lg" animation={true}
                    aria-labelledby="contained-modal-title-vcenter" dialogClassName="modal-tripDetails-width">
                    <Modal.Header className='activate_dialog_header_bgcolor tripDetails-DialogHeader user-select-none' closeButton>
                        <Modal.Title>{ TITLE }</Modal.Title>
                    </Modal.Header>
                    <Row className="first-row-tripDetails user-select-none">
                        <Col xs={3} className="py-1">
                            <label className="tripDetails-label text-nowrap float-start">
                                <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                    check_circle
                                </span>
                                <b>Confirmation#:{SPACES}</b></label>
                            <label className="tripDetails-label text-nowrap">{ConfirmationNumber}</label>
                        </Col>
                        <Col xs={2} className="py-1">
                            <label className="tripDetails-label text-nowrap float-start">
                                <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                    preliminary
                                </span>
                                <b>Status:{SPACES}</b></label>
                            <label className="tripDetails-label text-nowrap">{ServiceStatus}</label>
                        </Col>
                        <Col xs={3} className="py-1">
                            <label className="tripDetails-label text-nowrap float-start">
                                <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                    history_toggle_off
                                </span>
                                <b>ETA (Live Traffic):{SPACES}</b></label>
                            <label className="tripDetails-label text-nowrap">{"..."}</label>
                        </Col>
                        <Col xs={3} className="py-1">
                            <label className="tripDetails-label text-nowrap float-start">
                                <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                    fact_check
                                </span>
                                <b>Req. Type:{SPACES}</b></label>
                            <label className="tripDetails-label text-nowrap">{RequestType}</label>
                        </Col>
                        <Col xs={1}>
                            <Button className="tripDetails_edit_btn_color" size="sm" onClick={handleEditButton}>
                                {EDIT_BUTTON}
                            </Button>
                        </Col>
                    </Row>
                    <hr className="hr-tripDetails w-100"></hr>
                    <Modal.Body>
                            <Container>
                                <Row className="border rounded py-1">
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        person_pin_circle
                                                    </span>
                                                    Pickup Person:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <input className="tripDetails-label-dataFields w-100" 
                                                    placeholder="Enter Pickup Person Name" disabled={isEditButtonClicked}
                                                    value={PickupPerson}
                                                    onChange={ (e) => { ChangePickupPerson(e.target.value) }}
                                                />
                                                
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label mt-1">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        date_range
                                                    </span>
                                                    PU DateTime:
                                                </label>
                                            </Col>
                                            <Col xs={4} className="mt-1">
                                                <DatePicker className="tripDetails-label-dataFields w-100" selected={pickupDate} 
                                                onChange={ (date) => { handlePickupDateChange(date); }} disabled={isEditButtonClicked} />
                                            </Col>
                                            <Col  xs={3} className="mt-1">
                                                <TimePicker className="tripDetails-label-dataFields w-100" disabled={isEditButtonClicked} 
                                                    onChange={ (date) => { handleRequestPickupTimeChange(date); }} value={pickupTime} 
                                                    showSecond={false} allowEmpty format={"hh:mm A"} use12Hours />
                                                
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label mt-1">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        schedule
                                                    </span>
                                                    Appt Time:
                                                </label>
                                            </Col>
                                            <Col xs={7} className="mt-1">
                                                <TimePicker className="tripDetails-label-dataFields w-100" disabled={isEditButtonClicked} 
                                                        onChange={ (date) => { ChangeAppointmentTime(date); }} value={AppointmentTime} 
                                                        showSecond={false} allowEmpty format={"hh:mm A"} use12Hours />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label mt-1"> 
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        tag
                                                    </span>
                                                    Job#:
                                                </label>
                                            </Col>
                                            <Col xs={7} className="mt-1">
                                                <input className="w-100 tripDetails-label-dataFields" placeholder="Enter Job Number" disabled={isEditButtonClicked}
                                                    value={JobNumber} onChange={ (e) => {ChangeJobNumber(e.target.value)}}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                            
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        event
                                                    </span>
                                                    Received Date:</label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {ReceivedDate}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        cards
                                                    </span>
                                                    Created By:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {CreatedBy}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        person
                                                    </span>
                                                    Modified By:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {ModifiedBy}
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>
                                    
                                </Row>
                                <Row className="emptyTripDetailsRow"></Row>
                                <Row className="border rounded py-1">
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        garage
                                                    </span>
                                                    Req. Veh Type:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {RequestedVehicleType}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        garage
                                                    </span>
                                                    Req. Veh/Drv:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {RequestedVehicleDriver}
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        call
                                                    </span>
                                                    Drv Phone:</label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {DriverPhone}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        event
                                                    </span>
                                                    Last CB:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {LastCallback}
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="emptyTripDetailsRow"></Row>
                                <Row className="border rounded py-1">
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        multiple_stop
                                                    </span>
                                                    CB Method:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {CallbackMethod}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        info
                                                    </span>
                                                    CB Info:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <input className="tripDetails-label-dataFields w-100" placeholder="Enter Callback Info" disabled={isEditButtonClicked}
                                                    value={CallbackInfo} onChange={ (e) => {ChangeCallbackInfo(e.target.value)}}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">   
                                                        exclamation
                                                    </span>
                                                    Callout Status:</label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {CalloutStatus}
                                                </label>
                                            </Col>
                                        </Row>
                                    
                                    </Col>
                                </Row>
                                <Row className="emptyTripDetailsRow"></Row>
                                <Row className="border rounded py-1">
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        emoji_flags
                                                    </span>
                                                    Est. Miles:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {EstimatedMiles}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        attach_money
                                                    </span>
                                                    Est. Fare:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {EstimatedFare}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        hourglass_bottom
                                                    </span>
                                                    Est. Mins:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {EstimatedMins}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        functions
                                                    </span>
                                                    Instr Count:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {InstructionsCount}
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        emoji_flags
                                                    </span>
                                                    Prov. Miles:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {ProviderMiles}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        monetization_on
                                                    </span>
                                                    Prov. Fare:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {ProviderFare}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        credit_card
                                                    </span>
                                                    Pay Type:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {PayType}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        hdr_auto
                                                    </span>
                                                    Account:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {Account}
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="emptyTripDetailsRow"></Row>
                                <Row className="border rounded py-1">
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        where_to_vote
                                                    </span>
                                                    PU Address/POI:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {PickupAddressPOI}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        pin_drop
                                                    </span>
                                                    DO Address/POI:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {DropOffAddressPOI}
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        123
                                                    </span>
                                                    Pickup Zip:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {PickupZip}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        123
                                                    </span>
                                                    Dropoff Zip:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {DropOffZip}
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="emptyTripDetailsRow"></Row>
                                <Row className="border rounded py-1">
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label text-nowrap">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        remove_road
                                                    </span>
                                                    Total CXL/NS:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields">
                                                    {GetTotalCanclNoShow()}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label text-nowrap">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                    note_stack
                                                    </span>
                                                    Pickup Remarks:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <textarea rows={2} style={{resize:"none"}} className="tripDetails-label-dataFields float-start w-100" 
                                                    placeholder="Pickup Remarks here..." disabled={isEditButtonClicked}
                                                        value={pickRemarks} onChange={(e) => {ChangePickRemarks(e.target.value)}}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label text-nowrap">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                    note_stack
                                                    </span>
                                                    Dropoff Remarks:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <textarea rows={2} style={{resize:"none"}} className="tripDetails-label-dataFields float-start w-100" 
                                                        placeholder="Dropoff Remarks here..." disabled={isEditButtonClicked}
                                                            value={dropRemarks} onChange={(e) => {ChangeDropRemarks(e.target.value)}}
                                                />
                                            </Col>
                                        </Row>
                                        
                                    </Col>
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        page_info
                                                    </span>
                                                    Extra Info:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <textarea rows={6} style={{resize:"none"}} className="tripDetails-label-dataFields float-start w-100" placeholder="Enter Extra Info here" disabled={isEditButtonClicked}
                                                    value={ExtraInfo} onChange={(e) => {ChangeExtraInfo(e.target.value)}}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                            </Container>
                    </Modal.Body>
                    <Modal.Footer style={{backgroundColor:"#4c859b"}} className="p-1">
                        
                        <Button className="tripDetails_edit_btn_color" variant="success" onClick={handleValidateTripInformation}>
                            {SAVE_BUTTON}
                        </Button>
                    
                        <Button className="tripDetails_edit_btn_color" variant="secondary" onClick={handleCloseTripDetailsDialog}>
                            {CANCEL_BUTTON}
                        </Button>
                        
                    </Modal.Footer>
                </Modal>
            :""}
            {showActivationAlert ? 
                <Modal centered show={showActivationAlert} onHide={handleAlertModalClose} keyboard={true} animation={true} backdrop="static" >
                    <Modal.Header className='activate_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                    <Modal.Title className='activate_dialog_title_color user-select-none'>{activateAlert.alertTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="user-select-none"><b>{activateAlert.alertMsg}</b></Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleAlertModalClose}>
                        Close
                    </Button>
                    </Modal.Footer>
                </Modal>
            :""}

            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
            onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalCancel}
            btnOkText={confirmationModalObj.btnOkText} btnCanceText={confirmationModalObj.btnCanceText} ShowCancelButton="true"/>

        </>
    )
}

export default TripDetailsDialog;